import { sentenceCaseKey } from "@/lib/listFormat";

// BRK-S179 — turning an issued bond's TYPE into words.
//
// The issued-bonds row publishes `bondType` as a KEY, not a label. Since
// PMS-S500 (pinned at the sprint-10 release re-pin) that key is the ISSUANCE's
// bond kind — `bid`, `performance` or `payment` — rather than the form's
// discovery subproduct key, which bond forms no longer carry. A combined
// Performance & Payment form is two bonds, so two rows. The kinds are labelled
// here; the catalogue read the subproduct keys needed is gone with them.
//
// ── A LABEL IS NEVER A REASON TO DROP A ROW ─────────────────────────────────
//
// A kind this build has not mirrored (a row from before PMS-S500, or a kind PMS
// adds later) is humanised locally (`performance_payment` → "Performance
// payment") and the bond still lists. A row is a record of something Signal
// issued; a missing label is a worse day, not a reason to hide it.

/** The issuance kinds PMS-S500 publishes, in words. */
export const BOND_KIND_LABELS: Readonly<Record<string, string>> = {
  bid: "Bid bond",
  performance: "Performance bond",
  payment: "Payment bond",
};

/** `bid_bond` → "Bid bond" — the fallback for a key with no label. */
export function humaniseBondType(key: string): string {
  return sentenceCaseKey(key);
}

/** An issued bond's `bondType` in words: its kind's label, else the key
 *  humanised — never the raw key, never blank. */
export function bondTypeLabel(key: string): string {
  return Object.hasOwn(BOND_KIND_LABELS, key)
    ? BOND_KIND_LABELS[key]
    : humaniseBondType(key);
}
